import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (req.headers.has('Skip-Interceptor') && req.headers.get('Skip-Interceptor') === 'true') {
    const newRequest = req.clone({ headers: req.headers.delete('Skip-Interceptor') });
    return next(newRequest);
  }

  const urlLower = req.url.toLowerCase();
  if (
    urlLower.includes('/login') ||
    urlLower.includes('/forgotpassword') ||
    urlLower.includes('/resetpassword') ||
    urlLower.includes('blob.core.windows.net') ||
    urlLower.includes('?sv=') ||
    urlLower.includes('&sig=')
  ) {
    return next(req);
  }

  const token = authService.getToken();

  if (!token) {
    const currentUrl = router.url || '';
    if (!currentUrl.includes('/login') && !currentUrl.includes('/reset-password') && currentUrl !== '/') {
      authService.logOut(currentUrl);
    }
    return next(req);
  }

  const authReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`),
  });

  return next(authReq);
};
